export const LIST = "HISTORY_LIST";
export const CANCEL = "HISTORY_CANCEL";
export const APPLY_PROMO = "HISTORY_APPLY_PROMO";
export const LATEST = "HISTORY_LATEST";
export const UPDATE_PRIZE = "HISTORY_UPDATE_PRIZE";
export const GAME_LIST = "HISTORY_GAME_LIST";